import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_DETAIL_CHOVAY,
  GET_LANDONGLAI_CHOVAY,
  GET_TRANG_LANDONGLAI_CHOVAY,
  GET_LAIDENNGAY_CHOVAY,
  GET_LICHSUGIAHAN_CHOVAY,
  POST_GIAHAN_CHOVAY,
  GET_LICHSUTRABOTGOC_CHOVAY,
  POST_TRABOTGOC_CHOVAY,
  GET_LICHSUVAYTHEM_CHOVAY,
  POST_VAYTHEM_CHOVAY,
  POST_TATTOAN_CHOVAY,
  GET_TATTOAN_CHOVAY,
  DELETE_TRABOTGOC_CHOVAY,
  DELETE_VAYTHEM_CHOVAY,
  GET_LAIDENKY_CHOVAY,
  POST_THAYDOILAISUAT_CHOVAY,
  POST_THAYDOIKYTHANHTOAN_CHOVAY,
  POST_TATTOAN_CHODUYET_CHOVAY,

} from "actions/QuanLyChoVay/actionTypes";
import {
  getDetailChoVaySuccess,
  getDetailChoVayFailure,
  getLanDongLaiChoVaySuccess,
  getLanDongLaiChoVayFailure,
  getLaiDenNgayChoVaySuccess,
  getLaiDenNgayChoVayFailure,
  getLichSuGiaHanChoVaySuccess,
  getLichSuGiaHanChoVayFailure,
  postGiaHanChoVaySuccess,
  postGiaHanChoVayFailure,
  getLanDongLaiChoVay,
  getLichSuGiaHanChoVay,
  postThayDoiKyThanhToanChoVay,
  postThayDoiKyThanhToanChoVayFailure,
  postThayDoiKyThanhToanChoVaySuccess,
  getLichSuDoiKyThanhToanChoVay,
  getLichSuDoiKyThanhToanChoVaySuccess,
  getLichSuDoiKyThanhToanChoVayFailure,
  getLichSuTraBotGocChoVaySuccess,
  getLichSuTraBotGocChoVayFailure,
  postTraBotGocChoVaySuccess,
  postTraBotGocChoVayFailure,
  getLichSuTraBotGocChoVay,
  getLichSuVayThemChoVaySuccess,
  getLichSuVayThemChoVayFailure,
  postVayThemChoVaySuccess,
  postVayThemChoVayFailure,
  postThayDoiLaiSuatChoVaySuccess,
  postThayDoiLaiSuatChoVayFailure,
  getLichSuVayThemChoVay,
  postTatToanChoDuyetChoVayFailure,
  postTatToanChoDuyetChoVaySuccess,
  postTatToanChoVayFailure,
  postTatToanChoVaySuccess,
  deleteTraBotGocChoVaySuccess,
  deleteTraBotGocChoVayFailure,
  getTatToanChoVaySuccess,
  getTatToanChoVayFailure,
} from "actions/QuanLyChoVay";
import QuanLyChoVayApi from "service/quanLyChoVayApi";
import { pushNotification } from "utils/notifications";
import { updateValueObjThanhToan } from "actions/QuanLyThuChi";
import { showInPhieuThuChi } from "actions/InThuChi";

function* getDetailChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.list, action.dataSearch);
    if (response.data) {
      yield put(getDetailChoVaySuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_CENTER", 2000);
    yield put(getDetailChoVayFailure());
  }
}
function* getLanDongLai(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.lanThanhToan,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getLanDongLaiChoVaySuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getLanDongLaiChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getLanDongLaiChoVayFailure());
  }
}

function* getLaiDenNgay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.laiDenNgay, action.dataSearch);
    if (response.ok) {
      yield put(getLaiDenNgayChoVaySuccess(response.data));
      yield put(updateValueObjThanhToan(response.data));
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getLaiDenNgayChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getLaiDenNgayChoVayFailure());
  }
}
function* getLaiDenKy(action) {
  try {
    const response = yield call(QuanLyChoVayApi.laiDenKy, action.dataSearch);
    if (response.ok) {
      yield put(getLaiDenNgayChoVaySuccess(response.data));
      yield put(updateValueObjThanhToan(response.data));
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getLaiDenNgayChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getLaiDenNgayChoVayFailure());
  }
}
function* getLichSuGiaHan(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.lichSuGiaHan,
      action.dataSearch
    );
    if (response.ok) {
      yield put(
        getLichSuGiaHanChoVaySuccess({
          ListGiaHan: response.data.List,
          TotalRowGiaHan: response.data.totalRow,
        })
      );
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getLichSuGiaHanChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getLichSuGiaHanChoVayFailure());
  }
}
function* postGiaHanChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.giaHan, action.dataPost);
    if (response.ok) {
      if (response.data.Error == 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 4000);
        yield put(postGiaHanChoVayFailure());
      } else {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
        yield put(postGiaHanChoVaySuccess(response.data));
        yield put(
          getLichSuGiaHanChoVay({
            choVayId: action.dataSearch.choVayId,
            pageIndex: 1,
            pageSize: 2,
          })
        );
        yield put(getLanDongLaiChoVay(action.dataSearch));
      }
    } else {
      pushNotification("Thêm thất bại.", "error", "TOP_CENTER", 2000);
      yield put(postGiaHanChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thêm thất bại.", "error", "TOP_CENTER", 2000);
    yield put(postGiaHanChoVayFailure());
  }
}

function* getLichSuDoiKyThanhToan(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.lichSuGiaHan,
      action.dataSearch
    );
    if (response.ok) {
      yield put(
        getLichSuDoiKyThanhToanChoVaySuccess({
          ListDoiKyLai: response.data.List,
          TotalRowDoiKyLai: response.data.totalRow,
        })
      );
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getLichSuDoiKyThanhToanChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getLichSuDoiKyThanhToanChoVayFailure());
  }
}

function* getLichSuVayThem(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.lichSuVayThem,
      action.dataSearch
    );
    if (response.ok) {
      yield put(
        getLichSuVayThemChoVaySuccess({
          ListVayThem: response.data,
          TotalRowVayThem: response.data.length,
        })
      );
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getLichSuVayThemChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getLichSuVayThemChoVayFailure());
  }
}
function* postVayThemChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.vayThem, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postVayThemChoVayFailure());
      } else {
        // pushNotification(
        //   "Thêm phiếu thành công",
        //   "success",
        //   "TOP_CENTER",
        //   2000
        // );
        yield put(showInPhieuThuChi(response.data));
        yield put(postVayThemChoVaySuccess(response.data));
        yield put(getLanDongLaiChoVay(action.dataSearch));
        yield put(
          getLichSuVayThemChoVay({
            choVayId: action.dataSearch.choVayId,
            pageIndex: 1,
            pageSize: 5,
          })
        );
      }
    } else {
      pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 2000);
      yield put(postVayThemChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 2000);
    yield put(postVayThemChoVayFailure());
  }
}
function* postThayDoiKyThanhToan(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.thayDoiKyThanhToan,
      action.dataPost
    );
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postThayDoiKyThanhToanChoVayFailure());
      } else {
        pushNotification("Đổi lãi suất thành công", "success", "TOP_CENTER", 2000);
        yield put(postThayDoiKyThanhToanChoVaySuccess());
        yield put(getLanDongLaiChoVay(action.dataSearch));
        // yield put(
        //   getLichSuVayThemChoVay({
        //     choVayId: action.dataSearch.choVayId,
        //     pageIndex: 1,
        //     pageSize: 5,
        //   })
        // );
      }
    } else {
      pushNotification("Thêm phiếu thất bại 1.", "error", "TOP_CENTER", 2000);
      yield put(postThayDoiKyThanhToanChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thêm phiếu thất bại 2.", "error", "TOP_CENTER", 2000);
    yield put(postThayDoiKyThanhToanChoVayFailure());
  }
}
function* postThayDoiLaiSuat(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.thayDoiLaiSuat,
      action.dataPost
    );
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postThayDoiLaiSuatChoVayFailure());
      } else {
        pushNotification("Đổi lãi suất thành công", "success", "TOP_CENTER", 2000);
        yield put(postThayDoiLaiSuatChoVaySuccess());
        // yield put(getLanDongLaiChoVay(action.dataSearch));
        // yield put(
        //   getLichSuVayThemChoVay({
        //     choVayId: action.dataSearch.choVayId,
        //     pageIndex: 1,
        //     pageSize: 5,
        //   })
        // );
      }
    } else {
      pushNotification("Thêm phiếu thất bại 1.", "error", "TOP_CENTER", 2000);
      yield put(postThayDoiLaiSuatChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thêm phiếu thất bại 2.", "error", "TOP_CENTER", 2000);
    yield put(postThayDoiLaiSuatChoVayFailure());
  }
}
function* deleteVayThemChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.deleteVayThem, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postVayThemChoVayFailure());
      } else {
        pushNotification("Xóa phiếu thành công", "success", "TOP_CENTER", 2000);
        yield put(postVayThemChoVaySuccess(response.data));
        yield put(getLanDongLaiChoVay(action.dataSearch));
        yield put(
          getLichSuVayThemChoVay({
            choVayId: action.dataSearch.choVayId,
            pageIndex: 1,
            pageSize: 5,
          })
        );
      }
    } else {
      pushNotification("Xóa phiếu thất bại.", "error", "TOP_CENTER", 2000);
      yield put(postVayThemChoVayFailure());
    }
  } catch (error) {
    pushNotification("Xóa phiếu thất bại.", "error", "TOP_CENTER", 2000);
    yield put(postVayThemChoVayFailure());
  }
}
function* getLichSuTraBotGoc(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.lichSuTraBotGoc,
      action.dataSearch
    );
    if (response.ok) {
      yield put(
        getLichSuTraBotGocChoVaySuccess({
          ListTraBotGoc: response.data,
          TotalRowTraBotGoc: response.data.length,
        })
      );
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getLichSuTraBotGocChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getLichSuTraBotGocChoVayFailure());
  }
}
function* postTraBotGocChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.traBotGoc, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postTraBotGocChoVayFailure());
      } else {
        // pushNotification(
        //   "Thêm phiếu thành công",
        //   "success",
        //   "TOP_CENTER",
        //   2000
        // );
        yield put(showInPhieuThuChi(response.data));
        yield put(postTraBotGocChoVaySuccess(response.data));
        yield put(getLanDongLaiChoVay(action.dataSearch));
        yield put(
          getLichSuTraBotGocChoVay({
            choVayId: action.dataSearch.choVayId,
            pageIndex: 1,
            pageSize: 5,
          })
        );
      }
    } else {
      pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 2000);
      yield put(postTraBotGocChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 2000);
    yield put(postTraBotGocChoVayFailure());
  }
}

function* postTatToanChoDuyetChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.tatToanChoDuyet, action.dataPost);
    if (response.ok) {

      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postTatToanChoDuyetChoVayFailure());
      } else {
        if (response.data == "1") {
          pushNotification(
            "Tất toán chờ duyệt thành công.",
            "success",
            "TOP_CENTER",
            4000
          );
          yield put(postTatToanChoDuyetChoVaySuccess(response.data));
        } else {
          yield put(postTatToanChoDuyetChoVaySuccess(response.data));
        }
      }
    } else {
      pushNotification("Thao tác thất bại.", "error", "TOP_CENTER", 2000);
      yield put(postTatToanChoDuyetChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thao tác thất bại.", "error", "TOP_CENTER", 2000);
    yield put(postTatToanChoDuyetChoVayFailure());
  }
}
function* postTatToanChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.tatToan, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postTatToanChoVayFailure());
      } else {
        if (response.data == "-500") {
          pushNotification(
            "Tất toán thành công. Đã thực hiện hợp đồng theo cấu hình tất toán.",
            "success",
            "TOP_CENTER",
            4000
          );
          yield put(showInPhieuThuChi(response.data));
          yield put(postTatToanChoVaySuccess(response.data));
        } else {
          yield put(showInPhieuThuChi(response.data));
          //pushNotification("Tất toán thành công", "success", "TOP_CENTER", 2000);
          yield put(postTatToanChoVaySuccess(response.data));
        }
      }
    } else {
      pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 2000);
      yield put(postTatToanChoVayFailure());
    }
  } catch (error) {
    pushNotification("Thêm phiếu thất bại.", "error", "TOP_CENTER", 2000);
    yield put(postTatToanChoVayFailure());
  }
}
function* getTatToanChoVay(action) {
  try {
    const response = yield call(QuanLyChoVayApi.getTatToan, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        if (response.data.ThongTinTatToan)
          yield put(getTatToanChoVaySuccess(response.data.ThongTinTatToan));
        else yield put(getTatToanChoVayFailure());
      } else {
        yield put(getTatToanChoVaySuccess(response.data.ThongTinTatToan));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getTatToanChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getTatToanChoVayFailure());
  }
}
function* deleteTraBotGocChoVay(action) {
  try {
    const response = yield call(
      QuanLyChoVayApi.deleteTraBotGoc,
      action.dataPost
    );
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(postTatToanChoVayFailure());
      } else {
        pushNotification("Xóa phiếu thành công", "success", "TOP_CENTER", 2000);
        yield put(deleteTraBotGocChoVaySuccess(response.data));
        yield put(getLanDongLaiChoVay(action.dataSearch));
        yield put(
          getLichSuTraBotGocChoVay({
            choVayId: action.dataSearch.choVayId,
            pageIndex: 1,
            pageSize: 5,
          })
        );
      }
    } else {
      pushNotification("Xóa phiếu thất bại.", "error", "TOP_CENTER", 2000);
      yield put(deleteTraBotGocChoVayFailure());
    }
  } catch (error) {
    pushNotification("Xóa phiếu thất bại.", "error", "TOP_CENTER", 2000);
    yield put(deleteTraBotGocChoVayFailure());
  }
}
function* watchGetRequest() {
  yield takeLatest(GET_LANDONGLAI_CHOVAY, getLanDongLai);
  yield takeLatest(GET_LICHSUGIAHAN_CHOVAY, getLichSuGiaHan);
  yield takeLatest(POST_GIAHAN_CHOVAY, postGiaHanChoVay);
  yield takeLatest(GET_LAIDENNGAY_CHOVAY, getLaiDenNgay);
  yield takeLatest(GET_LAIDENKY_CHOVAY, getLaiDenKy);
  yield takeLatest(GET_DETAIL_CHOVAY, getDetailChoVay);
  yield takeLatest(GET_LICHSUVAYTHEM_CHOVAY, getLichSuVayThem);
  yield takeLatest(POST_VAYTHEM_CHOVAY, postVayThemChoVay);
  yield takeLatest(POST_THAYDOILAISUAT_CHOVAY, postThayDoiLaiSuat);
  yield takeLatest(POST_THAYDOIKYTHANHTOAN_CHOVAY, postThayDoiKyThanhToan);
  yield takeLatest(DELETE_VAYTHEM_CHOVAY, deleteVayThemChoVay);

  yield takeLatest(GET_LICHSUTRABOTGOC_CHOVAY, getLichSuTraBotGoc);
  yield takeLatest(POST_TRABOTGOC_CHOVAY, postTraBotGocChoVay);
  yield takeLatest(DELETE_TRABOTGOC_CHOVAY, deleteTraBotGocChoVay);
  yield takeLatest(POST_TATTOAN_CHOVAY, postTatToanChoVay);
  yield takeLatest(GET_TATTOAN_CHOVAY, getTatToanChoVay);
  yield takeLatest(POST_TATTOAN_CHODUYET_CHOVAY, postTatToanChoDuyetChoVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
